import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Validators, FormGroup, FormArray, FormControl } from '@angular/forms';
import { Store, select} from '@ngrx/store';
import { fromEventPattern, Observable } from 'rxjs';
import { Client, Filedescriptions, SFTPInfo, Filetype, ClientState, ALLSFTP,  ClientsAPIandSFTP,ClientFileInfoModel } from '@core/services/client/client.model';
import { ClientIdAsyncValidator, FileDescriptionAsyncValidator } from '../../components/clientid-async-validator';
import { ClientService } from '@core/services/client/client.service';
//import { ClientSupportService } from '@core/services/client/clientsupport.services';
//import * as clientActions from "../../state/client.actions";
//import * as fromClient from "../../state/client.reducer";

import { AuthService } from '@core/services/auth/auth.service';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { map, delay, withLatestFrom, filter, debounceTime } from 'rxjs/operators';
import { Subscription } from "rxjs";
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '@shared/components/confirm-dialog/confirm-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
//import { LocalStorageService } from '@core/services/local-storeage/local-storage.service';
//import * as lvsActions from "../../state/lvs_state/lvs.actions";
//import * as fromLVS from "../../state/lvs_state/lvs.reducer";
import { ClientFileInfoEditComponent } from './components/client-file-info-edit/client-file-info-edit.component';

@Component({
  selector: 'app-client-file-info-parent',
  templateUrl: './client-file-info-parent.component.html',
  styleUrls: ['./client-file-info-parent.component.scss']
})
export class ClientFileInfoParentComponent implements OnInit {

  @Input() Readonly: boolean;
  @Input() ClientId: number;
  @Input() IsLvsEnable: boolean;
  @Output('update')
  change: EventEmitter<number> = new EventEmitter<number>();
  @Output('sftpupdate')
  SFTPchange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output('apiupdate')
  APIchange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output('returnfileselected')
  filetypechange: EventEmitter<boolean> = new EventEmitter<boolean>();

  ClientFormGroup: FormGroup;
  //Clientlvsinfomodel: ClientlvsInfoModel;
  clientfileinfomodel: FormGroup;
  btnenable = true;
  selectedClient$: Observable<Client>;
  Client: Client;
  clients$: Observable<Client[]>;
  clientfilesformarray = new FormArray([]);
  formValueChanges$: Observable<Client>;
  selectedFileTypeData: any;
  selectedSFTPData: any;
  filetypes: Filetype[];
  sftpinfos: SFTPInfo[];
  sftpinfostemp: SFTPInfo[];
  isShow = false;
  ALLSFTP_Select = [];
  Descriptionsubscriptions: Subscription[] = [];
  preivousfileclient: boolean = true;
  previousapiClient: boolean = false;
  FileInfo_step = -1;
  //clientlvsnumbers: LVSInfos[];
  clientfiles: string[][];
  isSpaesClientAppIdRequired = false;

  delayedProgress$ = this.loader.progress$.pipe(
    delay(500),
    withLatestFrom(this.loader.progress$),
    map(v => v[1]),
  );

  selected = -1;

  constructor(public loader: LoadingBarService, 
   // private localStorageService: LocalStorageService, 
    private toastrService: ToastrService,
    private auth: AuthService,   
    private clientService: ClientService,
    private store: Store<ClientState>, public dialog: MatDialog, 
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    //private clientSupportService: ClientSupportService
    ) {

    this.ClientFormGroup = new FormGroup({
      id: new FormControl('', [Validators.min(0)]),
      corporationcode: new FormControl(''),
      corporationname: new FormControl(''),
      isactive: new FormControl(true),
      spacesclientappid: new FormControl('', [Validators.min(0)]),
      webapiusername: new FormControl(''),
      csrsusername: new FormControl(''),
      lastfilenumber: new FormControl('', [Validators.min(0)]),
      fileclient: new FormControl(true),
      apiclient: new FormControl(false),
      isenablelvs: new FormControl(false),
      clientfileinfomodel: this.clientfilesformarray
    });    

    if (this.auth.currentUserValue.role == "user") {
      this.btnenable = false;
    }
  }
/*
  newclientlvsinfo(): FormGroup {
    return new FormGroup({
      lvscustomernumber: new FormControl('', [Validators.min(0)]),
      isactive: new FormControl(true)
    });
  }*/

  newclientfileinfo(): FormGroup {
    return new FormGroup({
      id: new FormControl(0),
      filetypeid: new FormControl(''),
      sftpinfoid: new FormControl(''),
      isactive: new FormControl(true),
      filename: new FormControl(''),
      filenameexpression: new FormControl(''),
      fileextension: new FormControl(''),
      minutesbetweenchecks: new FormControl('', [Validators.min(0)]),
      minutestowait: new FormControl('', [Validators.min(0)]),
      sftpsourcefolder: new FormControl(''),
      sftpdestinationfolder: new FormControl(''),
      description: new FormControl(''),
      disableduplicatefilenamecheck: new FormControl(false),
      bypassemptyreturnfile: new FormControl(false),
      rejectedalertinpercent: new FormControl(false),
      rejectedalertthreshold: new FormControl('', [Validators.min(0)]),
      clientfileid: new FormControl(''),
    });
  }

  setFileInfoStep(index: number) {
    this.FileInfo_step = index;
  }

  get clientlvsinfo(): FormGroup { return this.ClientFormGroup.get('clientlvsinfomodel') as FormGroup }

  get clientfileinfos(): FormArray { return this.ClientFormGroup.get('clientfileinfomodel') as FormArray; }

  ngOnInit() {
   // this.spinner.show(); 
    this.loader.increment(50);
    this.loader.start();
    
    
    console.log('ngOnInit');
    this.route.queryParams.subscribe(value => {
      if (value) {
        if (value['id'] as number >= 0) {
          this.ClientId = value['id'] as number;
        }
        else {
          this.ClientId = -1;
        }
      }
    });

    console.log(' this.ClientId '+ this.ClientId);

    this.refesh();

    if (this.ClientId >= 0) {

      this.clientService.Getfiletype().subscribe(FileType => { this.filetypes = FileType as Filetype[] });
     this.clientService.GetSFTPInfo().subscribe(SFTPinfo => { 
        this.sftpinfostemp = SFTPinfo as SFTPInfo[];
        this.sftpinfos = SFTPinfo as SFTPInfo[];
        console.log('sftp array ' + this.sftpinfostemp.length);
        console.log('sftp array ' + this.sftpinfos.length);
       // this.refesh();
      });
      
      this.clientService.GetClientInputFileInfos(this.ClientId).subscribe(fileinfos => { 
        this.clientfiles = fileinfos as string[][];
        console.log(' this.clientfiles length '+ this.clientfiles.length);
      });


     /* this.clientService.getClientInfoById(this.ClientId).subscribe(value => {
        if (value) {
         this.client = value as Client;
          this.clientFormGroup.patchValue({ ...this.client });
          this.clientService.setTitleChanged('Manage Client | ' + this.client.corporationname);
          this.isReadOnly();
          this.spinner.hide()
          return;
        }
      });*/

      this.spinner.hide();
    }


 
  
   //   this.clientService.Getfiletype().subscribe(FileType => { this.filetypes = FileType as Filetype[] });
    /*  this.clientService.GetSFTPInfo().subscribe(SFTPinfo => { 
        this.sftpinfostemp = SFTPinfo as SFTPInfo[];
        this.sftpinfos = SFTPinfo as SFTPInfo[];
        this.refesh();
      });
      */
   /*   this.clientService.GetClientInputFileInfos(this.ClientId).subscribe(fileinfos => { 
        this.clientfiles = fileinfos as string[][] 
      });

      */

    /*  this.clientService.GetClientLVSInfo(this.ClientId).subscribe(data=>{       
        this.isSpaesClientAppIdRequired = data.lvscustomernumber!=="";
      });*/
     
    
   
  }

  IsReadOnly() {
    if (this.Readonly) {
      this.ClientFormGroup.disable();
    }
    else {
      this.ClientFormGroup.enable();
      if (this.ClientId > 0) {
        this.ClientFormGroup.get("id").disable();
      }
    }
  }

  Checking() {
    console.log('inside Checking');
    this.clientService.retrieveClientById(this.ClientId).subscribe(data => {     
        if (data.clientfileinfomodel) {
          console.log('inside Checking 1');
          console.log('inside Checking 1 data ' +data);
          console.log('inside Checking 1 data.corporationcode ' +data.corporationcode);
          //if(data.corporationcode )
          {
            console.log('inside Checking 2');
              this.Client= data;
              for (var i = 0; i < data.clientfileinfomodel.length; i++)
              {
                console.log('inside Checking 3');
                var sftps:SFTPInfo[]=[];
                this.ALLSFTP_Select.push(sftps);
                this.clientfilesformarray.push(this.newclientfileinfo());  
                this.ALLSFTP_Select[i].SFTPInfos =this.sftpinfostemp; 
                
             /*   if(data.clientfileinfomodel[i].parentclientfileinfoid != null)
                {
                  var parentclientfileinfoid = this.clientfileinfos.controls[i].get('clientfileid'); 
                  parentclientfileinfoid.setValue(data.clientfileinfomodel[i].parentclientfileinfoid.toString());
                }*/
              }
              
              this.ClientFormGroup.patchValue({ ... this.Client });
              //this.APIchange.emit(data.apiclient);
             // this.SFTPchange.emit(data.fileclient);
              this.IsReadOnly();           
              this.loader.complete();
              this.isShow = true;
              this.spinner.hide();
          }
        }       
    })

    console.log('inside Checking end');
  }

  refesh() {    
    if(this.ClientId==0)
    {
     // this.APIchange.emit(false);
      //this.SFTPchange.emit(true);
      this.loader.complete();
      this.spinner.hide();
      this.isShow = true;
    }
    else{
      console.log('inside refresh');
      console.log('inside refresh before Checking');
      this.Checking();
      console.log('inside refresh after Checking');
    }
  }

 
  addClientFileInfo() {  
    console.log('inside addClientFileInfo');
     
   var sftps:SFTPInfo[]=[];  
   this.ALLSFTP_Select.push(sftps);
   this.ALLSFTP_Select[this.ALLSFTP_Select.length-1].SFTPInfos =this.sftpinfostemp;   
  

  
    const dialogRef = this.dialog.open(ClientFileInfoEditComponent, {
      width: '1200px',
      height: '700px',
      data: { clientfile:null,clientid:this.ClientId},
    });
  

    
    dialogRef.afterClosed().subscribe(result =>{
      if(result != undefined)
      { 
        this.clientfileinfos.push(new FormGroup({
          id: new FormControl(result.id),
          filetypeid: new FormControl(result.filetypeid),
          sftpinfoid: new FormControl(result.sftpinfoid),
          isactive: new FormControl(result.isactive),
          filename: new FormControl(result.filename),
          filenameexpression: new FormControl(result.filenameexpression),
          fileextension: new FormControl(result.fileextension),
          minutesbetweenchecks: new FormControl(result.minutesbetweenchecks, [Validators.min(0)]),
          minutestowait: new FormControl(result.minutestowait, [Validators.min(0)]),
          sftpsourcefolder: new FormControl(result.sftpsourcefolder),
          sftpdestinationfolder: new FormControl(result.sftpdestinationfolder),
          description: new FormControl(result.description),
          disableduplicatefilenamecheck: new FormControl(result.disableduplicatefilenamecheck),
          bypassemptyreturnfile: new FormControl(result.bypassemptyreturnfile),
          rejectedalertinpercent: new FormControl(result.rejectedalertinpercent),
          rejectedalertthreshold: new FormControl(result.rejectedalertthreshold, [Validators.min(0)]),        
          clientfileid: new FormControl(result.parentclientfileinfoid==null?'':result.parentclientfileinfoid.toString()),
        }));
        console.log("check sftp after add file",this.ALLSFTP_Select);    
        this.ClientFormGroup.patchValue({ ... this.Client });
        this.setFileInfoStep(this.clientfileinfos.length - 1);
      }
    }) 
  }

 
  removeClientFileInfo(i: number) {   
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '350px',
      data: { fileindex:i, message: "Do you confirm to delete this client file?" }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log("check after delete",result);
      if(result === true)
      {       
        var fileid =this.ClientFormGroup.value.clientfileinfomodel[i].id;
        this.clientService.removeClientFileInfo(fileid,this.auth.currentUserValue.username).subscribe(deleted =>
          {
            if(deleted===true){    
              this.clientfileinfos.removeAt(i);   
              this.Client.clientfileinfomodel.splice(i,1);
              this.ClientFormGroup.patchValue({ ... this.Client });
              this.setFileInfoStep(-1);               
            }
          });              
      };       
    });         
  }

  updateAPIandSFTP() {
    const clientsAPIandSFTP: ClientsAPIandSFTP = {
      clientid: this.ClientId,
      apiclient: this.ClientFormGroup.get("apiclient").value,
      fileclient: this.ClientFormGroup.get("fileclient").value
    }
   // this.clientService.updateClientAPIandSFTP(clientsAPIandSFTP);
    this.previousapiClient = this.ClientFormGroup.get("apiclient").value;
    this.APIchange.emit(this.ClientFormGroup.get("apiclient").value);
    this.preivousfileclient = this.ClientFormGroup.get("fileclient").value;
    this.SFTPchange.emit(this.ClientFormGroup.get("fileclient").value);
  }

 createClient() {
  console.log('inside createClient');
     /*if (this.ClientFormGroup.valid) {
      this.Saveclientfileinfomodel();
      const newclient: Client = {
        isinsert: this.ClientId > 0 ? false : true,
        id: Number(this.ClientFormGroup.get("id").value),
        corporationcode: this.ClientFormGroup.get("corporationcode").value,
        corporationname: this.ClientFormGroup.get("corporationname").value,
        spacesclientappid: this.ClientFormGroup.get("spacesclientappid").value,
        webapiusername: this.ClientFormGroup.get("webapiusername").value,
        csrsusername: this.ClientFormGroup.get("csrsusername").value,
        fileclient: this.ClientFormGroup.get("fileclient").value,
        apiclient: this.ClientFormGroup.get("apiclient").value,
        lastfilenumber: this.ClientFormGroup.get("lastfilenumber").value,
        isactive: this.ClientFormGroup.get("isactive").value,
        isdeleted: false,
        lastupdatedby: this.auth.currentUserValue.username,
        clientlvsinfomodel:null,
        clientfileinfomodel: this.ClientFormGroup.get("clientfileinfomodel").value
      }
      console.log("newclient",newclient.isinsert);
      if(newclient.isinsert)
      {
        this.store.dispatch(new clientActions.CREATECLIENT(newclient as Client));          
      }
      else
      {
        this.store.dispatch(new clientActions.UPDATECLIENT(newclient as Client));   
      }
      this.store.dispatch(new clientActions.LOADCLIENT(this.ClientId)); 
      this.selectedClient$ = this.store.pipe(select(fromClient.getCurrentClient));
      this.selectedClient$.subscribe(data => {
      this.Client = data as Client;      
      if (this.Client) {
        this.ClientId = data.id;
      //  this.preivousfileclient = this.Client.fileclient;
      //  this.previousapiClient = this.Client.apiclient;
      }
      console.log("LOADCLIENT", data);  
        
      if(data)
      {
       if(!data.clientfileinfomodel)
       {
         data.clientfileinfomodel=[];
       }
       this.ClientFormGroup.patchValue({ ... data });
       if(data.id>0)
       {
          this.ClientFormGroup.get('id').disable();
       }
      }
       
      this.change.emit(this.ClientId);
      this.previousapiClient = this.ClientFormGroup.get("apiclient").value;
      this.APIchange.emit(this.ClientFormGroup.get("apiclient").value);
      this.preivousfileclient = this.ClientFormGroup.get("fileclient").value;
      this.SFTPchange.emit(this.ClientFormGroup.get("fileclient").value);
    });
      

      var n = 0;
      for (var i = 0; i < this.clientfileinfos.controls.length; i++) {
        if (this.clientfileinfos.controls[i].get('filetypeid').value === 2) {
          this.filetypechange.emit(true);
        }
        else {
          n = n + 1;
        }
      }

      if (n === this.clientfileinfos.controls.length) {
        this.filetypechange.emit(false);
      }
    
    }
    else {
      this.toastrService.error("Client: " + this.ClientFormGroup.get("corporationname").value + " has validation error, Please check each section in Client Tab.", "Validation Error")
    } */
  }
 

  Saveclientfileinfomodel() {
    for (var file in this.ClientFormGroup.get("clientfileinfomodel").value) {
      this.ClientFormGroup.get("clientfileinfomodel").value[file]['clientinfoId'] = this.ClientId;
      this.ClientFormGroup.get("clientfileinfomodel").value[file]['isdeleted'] = false;
      this.ClientFormGroup.get("clientfileinfomodel").value[file]['lastupdatedby'] = this.auth.currentUserValue.username
    }
  }

  gettxt_SFTPFolder(i: number): string {
    if (this.clientfileinfos.controls[i].get('filetypeid').value !== 1) {
      return 'SFTP Destination Folder';
    }
    else {
      return 'SFTP Report Destination Folder';
    }
  } 

  isFileDesExisting(i: number): boolean {
    return this.clientfileinfos.controls[i].get('description').hasError('FileDescriptionExist');
  }

  isIdexisting(): boolean {
    return this.ClientFormGroup.get('id').hasError('ClientIdExist');
  }

  onsftpChange(event) {

    console.log('event', event.checked);
    if (this.preivousfileclient != event.checked && this.ClientId > 0) {
      this.openDialog(false);
    }

  }

  onapiChange(event) {
    console.log('event', event.checked);
    if (this.previousapiClient != event.checked && this.ClientId > 0) {
      this.openDialog(true);
    }
  }

  openDialog(isapi: boolean): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '350px',
      data: { isapi: isapi, message: "Do you confirm to save your settings?" }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('Yes clicked');
        this.updateAPIandSFTP();
      }
      else {
        console.log('No clicked');
        if (isapi) {
          this.ClientFormGroup.get('apiclient').setValue(this.previousapiClient);
        }
        else {
          this.ClientFormGroup.get('fileclient').setValue(this.preivousfileclient);
        }

      }
    });
  } 

  
  edit(value:any)
  {
    console.log('inside the edit');
    const dialogRef = this.dialog.open(ClientFileInfoEditComponent, {
      width: '1200px',
      height: '700px',
      data: { clientfile:value,clientid:this.ClientId},
    });

    dialogRef.afterClosed().subscribe(result => { 
      if(result != undefined)
      {
        for(var i =0; i<this.clientfileinfos.controls.length;i++)
        {
          if(this.clientfileinfos.controls[i].get('id').value === result.id)
          {
            var isactive =this.clientfileinfos.controls[i].get('isactive');
            var sftpinfo = this.clientfileinfos.controls[i].get('sftpinfoid');
            var filetype = this.clientfileinfos.controls[i].get('filetypeid');
            var filename = this.clientfileinfos.controls[i].get('filename');
            var filenameexpression = this.clientfileinfos.controls[i].get('filenameexpression');
            var minstowait = this.clientfileinfos.controls[i].get('minutestowait');
            var minsbtwchecks = this.clientfileinfos.controls[i].get('minutesbetweenchecks');
            var filedescription = this.clientfileinfos.controls[i].get('description');
            var fileextension = this.clientfileinfos.controls[i].get('fileextension');
            var sourcefolder = this.clientfileinfos.controls[i].get('sftpsourcefolder');
            var destinationfolder = this.clientfileinfos.controls[i].get('sftpdestinationfolder');
            var disableduplicatefilenamecheck = this.clientfileinfos.controls[i].get('disableduplicatefilenamecheck');
            var bypassemptyreturnfile = this.clientfileinfos.controls[i].get('bypassemptyreturnfile');
            var rejectedalertthreshold = this.clientfileinfos.controls[i].get('rejectedalertthreshold'); 
            var rejectedalertinpercent = this.clientfileinfos.controls[i].get('rejectedalertinpercent'); 
            var parentclientfileinfo = this.clientfileinfos.controls[i].get('clientfileid');       
            isactive.setValue(result.isactive);             
            this.ALLSFTP_Select[i].SFTPInfos = this.sftpinfostemp.filter(x => x.id == result.sftpinfoid);  
            sftpinfo.setValue(result.sftpinfoid);
            filename.setValue(result.filename);
            filetype.setValue(result.filetypeid);
            filenameexpression.setValue(result.filenameexpression);
            minstowait.setValue(result.minutestowait);         
            minsbtwchecks.setValue(result.minutesbetweenchecks);
            filedescription.setValue(result.description);
            fileextension.setValue(result.fileextension);
            sourcefolder.setValue(result.sftpsourcefolder);
            destinationfolder.setValue(result.sftpdestinationfolder);
            disableduplicatefilenamecheck.setValue(result.disableduplicatefilenamecheck);
            bypassemptyreturnfile.setValue(result.bypassemptyreturnfile);
            rejectedalertthreshold.setValue(result.rejectedalertthreshold);
            rejectedalertinpercent.setValue(result.rejectedalertinpercent);
           // parentclientfileinfo.setValue(result.parentclientfileinfoid.toString());
          }
        } 
      }     
    });  
  }




} 